import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.154 8.926C5.154 6 7.431 4.104 10 4.104S14.846 6 14.846 8.926c0 .862-.337 1.87-1.114 3.043-.775 1.171-1.962 2.462-3.586 3.871a.22.22 0 0 1-.292 0c-1.624-1.409-2.81-2.7-3.586-3.87-.777-1.173-1.114-2.182-1.114-3.044M10 2.552c-3.334 0-6.398 2.501-6.398 6.374 0 1.268.492 2.574 1.372 3.9.88 1.33 2.177 2.724 3.863 4.186.667.58 1.659.58 2.326 0 1.686-1.462 2.983-2.857 3.863-4.185s1.372-2.633 1.372-3.9c0-3.874-3.064-6.375-6.398-6.375m-1.514 9.285a.1.1 0 0 1-.1.1h-.754a.1.1 0 0 1-.1-.1V6.77a.1.1 0 0 1 .1-.1h.754a.1.1 0 0 1 .1.1zM9.52 6.77a.1.1 0 0 1 .1-.1h1.875q.607 0 1.019.226.414.226.625.622.213.394.213.895 0 .507-.213.9a1.53 1.53 0 0 1-.63.62q-.417.225-1.027.224h-.908a.1.1 0 0 0-.1.1v1.58a.1.1 0 0 1-.1.1H9.62a.1.1 0 0 1-.1-.1zm1.054 2.603a.1.1 0 0 1-.1-.1V7.567a.1.1 0 0 1 .1-.1h.774q.358 0 .584.12.23.12.337.333.11.214.11.493 0 .28-.11.497a.78.78 0 0 1-.334.34 1.2 1.2 0 0 1-.582.123h-.78Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIp;
